import React from "react";
import { useField } from "formik";

import { InputField } from "kubra-ux-forge";
import { getWcagAutocompleteValue } from "utilities/wcag";

interface NonBlankTextProps {
  label: string;
  name: string;
  placeholder?: string;
  editableIfPrefilled?: boolean;
}

export const NonBlankText: React.FC<NonBlankTextProps> = ({
  name,
  label,
  placeholder,
  editableIfPrefilled,
}) => {
  const [field, meta] = useField(name);

  let disabled = false;

  if (meta.initialValue && !editableIfPrefilled) {
    disabled = true;
  }

  return (
    // TODO: use appropriate class.
    <div className="bank-account-name-textbox-container">
      <InputField
        {...field}
        label={label}
        name={name}
        errorText={meta.touched ? meta.error : undefined}
        hasError={meta.touched ? !!meta.error : false}
        aria-invalid={meta.touched && !!meta.error}
        dataCy={name}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete={getWcagAutocompleteValue(name, label)}
      />
    </div>
  );
};
